import React, { useState, useEffect, useRef } from "react";
import { Box, DataGrid, DateBox, DropDownBox } from "devextreme-react";
import { Item } from "devextreme-react/box";
import { Column, Selection, Paging, FilterRow, Scrolling, Export, Button, Editing  } from "devextreme-react/data-grid";
import { useDispatch, useSelector } from 'react-redux';

import Nuevo from '../../bills/Nuevo';
import http from "../../../utils/http";
import Title from "../../../components/shared/Title";
import BlockHeader from "../../../components/shared/BlockHeader";
import { cellRender } from "../../../utils/common";
import { formatDate } from "../../../data/app";
import useItems from "../../../hooks/useItems";
import { getConfig } from "../../../data/bill";
import { billDialogAction } from "../../../store/bill/billDialogReducer";
import { getOutWithServices } from "../../../utils/custom";

const Kardex = () => {

    let dropDownBoxRef = useRef();
    
    const [ date, setDate ] = useState(null);
    const { items } = useItems({ open: true});
    const [ gridBoxValue, setGridBoxValue ] = useState([]);  

    const [ kardex, setKardex ] = useState([]);
    const [ saldoAnterior, setSaldoAnterior ] = useState(0);
    const dispatch = useDispatch();

    const changeHandler = e => setGridBoxValue(e.value);
    

    const dataGrid_onSelectionChanged = (e) => {     

        setGridBoxValue(e.selectedRowKeys[0].id);
        dropDownBoxRef.current.instance.close();            

    }

    const dataGridRender = () => {
        return (
          <DataGrid
            dataSource={getOutWithServices(items)}
            hoverStateEnabled={true}
            selectedRowKeys={gridBoxValue}
            onSelectionChanged={dataGrid_onSelectionChanged}
            height="100%">            
            <Selection mode="single" />
            <Scrolling mode="infinite" />
            <Paging enabled={true} pageSize={10} />
            <FilterRow visible={true} />
            <Column dataField="type" caption="Tipo" groupIndex={0}></Column>
            <Column dataField="id" caption="id" width={80} visible={false}></Column>
            <Column dataField="code" caption="Codigo" width={80}></Column>
            <Column dataField="name" caption="Nombre"></Column>        
          </DataGrid>
        );
    }

    const changeDate = e => {
        setDate(e.value)
    }

    useEffect(() => {
        if(gridBoxValue && date)
            http('reports/kardex').asPost({ productId : gridBoxValue, date}).then(resp => {
                setKardex(resp.result)
                setSaldoAnterior(resp.saldoAnterior)
            });      
    }, [gridBoxValue, date]);

    const stockcellRender = (cellData) => {
        return (
            <div className={cellData.data.quantityIn > 0 ? 'inc' : 'dec'} >             
              <div className='diff'>{cellData.value}</div>
            </div>
          );
    }

    const findMove = (e) => {

        const { id } = e.row.data;        
        dispatch(billDialogAction({ open: true, id }));


        
    }

    const isVisible = e => e.row.data.type == 'Facturacion';
    
    const onCellPrepared = e => {

        const cellsIn = ['quantityIn', 'costIn','costTotalIn'];
        const cellsOut = ['quantityOut', 'costOut','costTotalOut'];
            
        if (e.rowType == 'data') {

            if(cellsIn.includes(e.column.dataField) && e.row.data.direccion == 1)
                e.cellElement.classList.add('cell-ins');

            if(cellsOut.includes(e.column.dataField) && e.row.data.direccion == 2)
                e.cellElement.classList.add('cell-outs');
          
        }

    }

    const config = getConfig(2);

    const title ='Kardex';  
    
    const result = getOutWithServices(items);

    console.log(result);

    return (
        <div className="container big">
            <Title title={title} />
            <BlockHeader title={title} />
            <Nuevo onSave={() => {}} config={config} />
            <Box direction="row" width="100%" height={75}>                
                <Item ratio={2}>
                    <div className="ml-10">
                        <label>Seleccione un item:</label>
                        <DropDownBox 
                            ref={dropDownBoxRef}
                            dataSource={getOutWithServices(items)}
                            key="id"
                            placeholder="Selecciona un producto"
                            showClearButton={true} 
                            valueExpr="id"      
                            displayExpr={item => item ? `${item.id} - ${item.name}` : ''} 
                            value = {gridBoxValue}              
                            onValueChanged={changeHandler} 
                            contentRender={dataGridRender}                        
                        />
                    </div>
                </Item>
                <Item ratio={1}>
                    <div className="ml-10">
                        <label>Seleccione la fecha de corte:</label>
                        <DateBox type="date" displayFormat={formatDate} openOnFieldClick={true} onValueChanged={changeDate}/>
                    </div>
                </Item>
            </Box>
            <Box direction="row" width="100%" height={75}>

                <Item ratio={1}>
                    <label>Kardex</label>
                    <DataGrid
                        dataSource={[{ stocks : saldoAnterior, type:'Saldo Anterior',id:'-', date: date  }]}
                        showBorders={true}
                        showRowLines={true}
                    >                       
                        <Export enabled={false} fileName={title} allowExportSelectedData={true} />
                        <Column dataField="tem" caption="Opt" width={50} />
                        <Column dataField="type" caption="Saldo Antorior" width={150} />
                        <Column dataField="id" caption="Documento" width={100} alignment="right"/>
                        <Column dataField="date" dataType="date" caption="Fecha" format={formatDate}  width={100} />
                        <Column dataField="reference" caption="Referencia" />                        
                        <Column dataField="stocks" caption="Existencia"  width={80} />
                    </DataGrid>
                    <DataGrid
                        id="gridContainer"
                        dataSource={kardex}
                        showBorders={true}
                        showRowLines={true}
                        onCellPrepared={onCellPrepared}
                    >                       
                        <Export enabled={false} fileName={title} allowExportSelectedData={true} />
                        <Column type="buttons" width={50}>
                            <Button name="edit" hint="Ver movimientos"  icon="find" onClick={findMove} visible={isVisible}/>
                        </Column>
                        <Column dataField="type" caption="Tipo" width={150} />
                        <Column dataField="id" caption="Documento" width={100} />
                        <Column dataField="date" dataType="date" caption="Fecha" format={formatDate}  width={100} />
                        <Column dataField="reference" caption="Referencia" />
                        <Column caption="Entradas" alignment="center">
                            <Column dataField="quantityIn" caption="Cantidad"  width={75} />
                            <Column dataField="costIn" caption="Costo" cellRender={cellRender()} width={100} alignment="right" />
                            <Column dataField="costTotalIn" caption="Total" cellRender={cellRender()} width={115} alignment="right"/>
                        </Column>                        
                        <Column caption="Salidas" alignment="center">
                            <Column dataField="quantityOut" caption="Cantidad"  width={75} />
                            <Column dataField="costOut" caption="Costo" cellRender={cellRender()} width={100} alignment="right"/>
                            <Column dataField="costTotalOut" caption="Total" cellRender={cellRender()} width={115} alignment="right"/>
                        </Column>   
                        <Column caption="Existencias" alignment="center">
                            <Column dataField="stocks" caption="Existencia" width={80} cellRender={stockcellRender} />
                            <Column dataField="costAvg" caption="Costo Prom" cellRender={cellRender()} width={100} alignment="right"/>
                            <Column dataField="costPromOut" caption="Total" cellRender={cellRender()} width={115} alignment="right"/>
                        </Column>    
                        <Editing
                            mode="popup"
                            allowUpdating={true}                           
                            useIcons={true}
                        >
                        </Editing>                  
                    </DataGrid>
                </Item>

            </Box>

        </div>
    );
}

export default Kardex;
